export const SET_FACILITIES = 'SET_FACILITIES';
export const SET_FACILITY = 'SET_FACILITY';
export const ADD_FACILITY = 'ADD_FACILITY';
export const UPDATE_FACILITY = 'UPDATE_FACILITY';
export const REMOVE_FACILITY = 'REMOVE_FACILITY';
export const CLEAR_FACILITY = 'CLEAR_FACILITY';
export const CLEAR_FACILITIES = 'CLEAR_FACILITIES';
